import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';


const WhatsAppButton = () => {
  return (
    <div className="whatsapp-btn-container">
      <a
        href="https://wa.me/+5493424275255"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn"
      >
        <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-icon" />
      </a>
      <div className="whatsapp-message">Necesita ayuda?</div>
    </div>
  );
};

export default WhatsAppButton;

